import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueMask from "v-mask";
import SnackbarPlugin from "./plugins/snackbar";
import i18n from "@/i18n";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import Chat from "@/components/modules/help/chat/Chat.vue";
import Lottie from "vue-lottie";
import "animate.css";
import "./assets/styles/_main.scss";
import "tiptap-vuetify/dist/main.css";
import money from "vuejs-money";
Vue.component("ChatHelp", Chat);

Vue.use(SnackbarPlugin);
Vue.use(VueMask);
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: "mdi",
});
Vue.component("vue2-lottie", Lottie);
Vue.use(money);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
